<script lang="ts">
    import {enhance} from "$app/forms";
    import CardLayout from "$items/CardLayout.svelte";
    import type {Employee} from "$lib/types/employee";
    import InfoBox from "$items/InfoBox.svelte";
    import type {Writable} from "svelte/store";
    import {getContext, onMount} from "svelte";
    import ApplyTrigger from "$items/employee/ApplyTrigger.svelte";
    import {Button, Hr, Select, Textarea, Toggle} from "flowbite-svelte";
    import type {EmployeeExtra} from "$lib/types/employee";
    import VerticalGrid from "$lib/components/VerticalGrid.svelte";
    import {PenOutline} from "flowbite-svelte-icons";
    import CardLayoutSubmitButton from "$items/employee/form/CardLayoutSubmitButton.svelte";
    import IncompleteDataWarning from "$lib/components/IncompleteDataWarning.svelte";
    import {page} from "$app/stores";

    export let readOnly = false;
    let loading = false;
    let display = false;
    const employee_extra: Writable<EmployeeExtra> = getContext('employee_extra');

    let employee: Writable<Employee> = getContext('employee');
    let super_edit: Writable<boolean> = getContext('super_edit');
    let groupStatuses: {value: string, name: string}[] = [];

    $: complete = $employee.cv.degree && $employee.cv.graduation && $employee.cv.shirtSize && $employee.cv.pantsSize
            && $employee.cv.shoeSize && $employee.cv.height && $employee.cv.hairColor
    onMount(async () => {
        // groupStatuses = (await $page.data.lazy_group_status).map((item:any) => ({...item, name: item.value}))
    })
</script>

<CardLayout title="Qualifikationen" bind:display accordion>
    <svelte:fragment slot="card-header">
        <IncompleteDataWarning {complete}/>
        {#if !readOnly}
            <Button color="yellow" class="!p-2" pill outline on:click={() => $super_edit = !$super_edit}>
                <PenOutline class="w-4 h-4"/>
            </Button>
        {/if}
    </svelte:fragment>
    <form class="px-2 py-3"
          class:opacity-20={loading}
          method="post"
          use:enhance={() => {loading=true;return ({ update }) => {loading=false; update({ reset: false })}}}
          action="?/update_employee_qualifications">
        <VerticalGrid>
            <InfoBox title="Schulabschluss"
                     value={$employee.cv.graduation} name="graduation"
                     type="select"
                     items={$employee_extra.graduations?.map(n => ({...n, name: n.value}))} />
<!--            <InfoBox title="Gruppenstatus" items={groupStatuses} value={$employee.cv.currentStatus} type="select" name="cv_currentStatus"/>-->
            <InfoBox title="Hemdgröße" value={$employee.cv.shirtSize} name="shirtSize"/>
            <InfoBox title="Schuhgröße (EU)" type="number" step="0.5" value={$employee.cv.shoeSize} name="shoeSize"/>
            <InfoBox title="Körpergröße (cm)" value={$employee.cv.height} name="height"/>
            <svelte:fragment slot="right">
                <InfoBox title="Ausbildung" value={$employee.cv.degree} name="degree"/>

                <InfoBox title="Hosengröße" value={$employee.cv.pantsSize} name="pantsSize"/>
                <InfoBox title="Führerschein"
                         value={$employee.cv?.motorVehicleLicense !== '0' ? 'Ja' : 'Kein Führerschein'}
                         let:value
                         let:x_name>
                    <Toggle
                        name="motorVehicleLicense" id="{x_name}"
                        on:change={(ev) => $employee.cv.motorVehicleLicense = ev.target.checked ? 'car' : '0'}
                        value={$employee.cv.motorVehicleLicense}
                        checked={$employee.cv.motorVehicleLicense !== '0'}/>
                </InfoBox>

                <InfoBox title="Haarfarbe" value={$employee.cv.hairColor} name="hairColor"/>
            </svelte:fragment>
        </VerticalGrid>
        <Hr/>
        <div class="px-2 ">
            <InfoBox title="Erfahrung" value={$employee.cv.workExperiences} name="workExperiences">
                <Textarea name="workExperiences" bind:value={$employee.cv.workExperiences} />
            </InfoBox>
        </div>
        <CardLayoutSubmitButton/>
        <ApplyTrigger {loading}/>
    </form>
</CardLayout>